export default "/signup/_next/static/chunks/fonts/inter-v3-latin-500-ec00a23a38d03875cf08cea7e310aa60.woff2";